/**
 * Created by esalazar on 9/12/17.
 * Service for The Automatic Event Insertion

 */
(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .factory('AutomaticEventService', AutomaticEventService);

    AutomaticEventService.$inject = ['PlanningEventsService', 'SoopkitchenUtils'];

    function AutomaticEventService(PlanningEventsService, SoopkitchenUtils) {

        var AUTOMATIC_EVENTS_STATUS = {

            ATT_DIST_TO_BE_APPLIED : {key: 'ATT_DIST_TO_BE_APPLIED', description: 'ATT_DIST Events',
                eventService: generateAttDist},

            EMC_PREF_NOISY_AUTO_TO_BE_APPLIED : {key: 'EMC_PREF_NOISY_AUTO_TO_BE_APPLIED', description: 'Automatic EMC_PREF_NOISY Events',
                eventService: generateAutoEmcPrefNoisy},

            EMC_PREF_NOISY_GUARANTEE_MIN_TO_BE_APPLIED:{key: 'EMC_PREF_NOISY_GUARANTEE_MIN_TO_BE_APPLIED',description: 'EMC_PREF_NOISY Events'
                , selectDates : true, hasMinimumDuration : true,
                apply: guaranteeEmcPrefNoisy, finish: finishedEmcPrefNoisy},

            EMC_MAND_QUIET_AUTO_TO_BE_APPLIED : {key: 'EMC_MAND_QUIET_AUTO_TO_BE_APPLIED',
                description: 'Automatic EMC_MAND_QUIET Events',
                eventService: generateAutoEmcMandQuiet},

            EMC_MAND_QUIET_GUARANTEE_MIN_TO_BE_APPLIED: {key: 'EMC_MAND_QUIET_GUARANTEE_MIN_TO_BE_APPLIED',description: 'EMC_MAND_QUIET Events',
                selectDates : true, hasMinimumDuration : true,  hasTimeSlot : true, hasBackupTimeSlot : true, check: guaranteeEmcMandQuietPrevious,
                apply: guaranteeEmcMandQuiet, finish: finishedEmcMandQuiet},

            IS_COORD_BURST_GUARANTEE_MIN_TO_BE_APPLIED : {key: 'IS_COORD_BURST_GUARANTEE_MIN_TO_BE_APPLIED',description: 'IS_COORD_BURST Events',
                selectDates : true, hasMinimumDuration : false,
                apply: guaranteeIsCoordBurst, finish: finishedIsCoordBurst},

            FINISHED: {key: 'FINISHED',description: 'FINISHED'}

        };

        return {
            getStatus : getStatus,
            AUTOMATIC_EVENTS_STATUS : AUTOMATIC_EVENTS_STATUS
        };

        function getStatus(key) {
            for ( var status in AUTOMATIC_EVENTS_STATUS) {
                if (AUTOMATIC_EVENTS_STATUS[status].hasOwnProperty('key') && AUTOMATIC_EVENTS_STATUS[status].key === key) {
                    return AUTOMATIC_EVENTS_STATUS[status];
                }
            }

        }

        function generateAttDist(planLabel) {
            generateAutoEvent(PlanningEventsService.generateAttDist, planLabel);
        }

        function generateAutoEmcPrefNoisy(planLabel) {
            generateAutoEvent(PlanningEventsService.generateAutoEmcPrefNoisy, planLabel);
        }

        function generateAutoEmcMandQuiet (planLabel) {
            generateAutoEvent(PlanningEventsService.generateAutoEmcMandQuiet, planLabel);

        }
        function guaranteeEmcPrefNoisy (planLabel, startTime, endTime,minDuration, windowDuration) {
            guaranteeEvent (PlanningEventsService.guaranteeEmcPrefNoisy, planLabel, startTime, endTime,minDuration, windowDuration)
        }

        function guaranteeEmcMandQuietPrevious (planLabel, startTime, endTime,minDuration, windowDuration, callback, timeSlot, backupTimeSlot) {
            guaranteeEvent (PlanningEventsService.guaranteeEmcMandQuietPrevious, planLabel, startTime, endTime,minDuration, windowDuration, callback, timeSlot, backupTimeSlot)
        }
        function guaranteeEmcMandQuiet (planLabel, startTime, endTime,minDuration, windowDuration, callback, timeSlot, backupTimeSlot, isCoordBurstAutomatic) {
            guaranteeEvent (PlanningEventsService.guaranteeEmcMandQuiet, planLabel, startTime, endTime,minDuration, windowDuration, callback, timeSlot, backupTimeSlot, isCoordBurstAutomatic)
        }
        function guaranteeIsCoordBurst (planLabel, startTime, endTime,minDuration, windowDuration) {
            guaranteeEvent (PlanningEventsService.guaranteeIsCoordBurst, planLabel, startTime, endTime,minDuration, windowDuration)
        }

        function finishedEmcPrefNoisy (planLabel) {
            finishedEvent(PlanningEventsService.finishedEmcPrefNoisy, planLabel);
        }

        function finishedIsCoordBurst (planLabel) {
            finishedEvent(PlanningEventsService.finishedIsCoordBurst, planLabel)
        }

        function finishedEmcMandQuiet (planLabel) {
            finishedEvent(PlanningEventsService.finishedEmcMandQuiet, planLabel)
        }

        function finishedEmcMandQuietPrevious (planLabel) {
            //TODO

        }
        function reloadCallback() {
            location.reload();
        }

        function errorCallback(response) {
            SoopkitchenUtils.prettyError(response, reloadCallback);
        }

        function generateAutoEvent(resourceFunction, planLabel) {
            resourceFunction(
                {
                    planLabel : planLabel
                },
                function successCallback(response) {
                    SoopkitchenUtils.invokeSweetAlert("Nice!", response.comment, "success", reloadCallback);
                },
                errorCallback);
        }

        function guaranteeEvent (resourceFunction, planLabel, startTime, endTime, minDuration, windowDuration, callback, timeSlot, backupTimeSlot, isCoordBurstAutomatic) {
            console.debug("guaranteeEvent");
            console.debug("timeSlot" + timeSlot);
            console.debug("backupTimeSlot" + backupTimeSlot );

            resourceFunction(
                {
                    planLabel : planLabel,
                    startTime : startTime,
                    endTime : endTime,
                    minDuration : minDuration,
                    windowDuration : windowDuration,
                    timeSlot :timeSlot,
                    backupTimeSlot :backupTimeSlot,
                    isCoordBurstAutomatic:isCoordBurstAutomatic
                },
                function successCallback(response) {
                    if (callback == null) {
                        SoopkitchenUtils.invokeSweetAlert("Nice!", response.comment, "success", reloadCallback);
                    } else {
                        callback(response);
                    }
                },
                errorCallback);
        }

        function finishedEvent(resourceFunction, planLabel) {
            resourceFunction(
                {
                    planLabel: planLabel
                },
                reloadCallback,
                errorCallback);
        }
    }
})();
